import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

class Footer extends React.Component {
  render() {
    return(
      <Container>
        {/* <TitleContainer>
          <NavItem>&copy; 2018 - Amy E. Zimmerman</NavItem>
        </TitleContainer> */}
        <ContainerNav>
          <NavItem>&copy; 2019 - Amy E. Zimmerman</NavItem>
          {this.props.location.pathname === '/' &&
          <NavItem><span>Lead photo by </span>
            <FooterLink
              href="https://unsplash.com/photos/ewtdGmhY1vI?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              target="_blank">Aaron Bean
            </FooterLink>
            <span> on </span>
            <FooterLink
              href="https://unsplash.com/search/photos/chicago?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              target="_blank">Unsplash
            </FooterLink>
          </NavItem>
        }
        <NavItem>
          <span>{'</>'} with love by </span>
          <FooterLink
            href="http://andrewzim.com"
            target="_blank">AndrewZim
          </FooterLink>
          <span> using </span>
          <FooterLink
            href="https://gatsbyjs.org"
            target="_blank">Gatsby.js
          </FooterLink>
          <span>, </span>
          <FooterLink
            href="https://contentful.com"
            target="_blank">Contentful
          </FooterLink>
          <span>, and </span>
          <FooterLink
            href="https://netlify.com"
            target="_blank">Netlify
          </FooterLink>
          <span>.</span>
        </NavItem>

        </ContainerNav>
      </Container>
    );
  }
}

export default Footer

const Container = styled.div`
  background: #333;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: 100px;
  padding: 10px 0;
  font-family: Lato, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;

`;

const TitleContainer = styled.div`
  margin: 0 auto;
  padding: 10px 10px;
  flex: 1 1 auto;
`
const ContainerNav = styled.div`
  list-style: none;
  padding: 10px 10px;
  text-align: center;
  margin: auto;
`

const NavItem = styled.h1`
  margin: 0;
  font-size: 0.8rem;
  line-height: 2rem;
  display: block;
  color: #888;
  opacity: 0.7;
  text-decoration: none;
  font-weight: 300;
  padding: 0px 10px;

  &:first-of-type {
    font-size: 1rem;
  }
`;

const FooterLink = styled.a`
  color: #888;
  opacity: 0.5;
  font-weight: 400;
  ${'' /* text-decoration: none; */}
`;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js